import request from '@/utils/request'; // 服务名：ecargocredit
//投保申请查询

export function insureApplyQuery(data) {
  return request({
    url: '/ecargocredit/credit/insureApplyQuery',
    method: 'post',
    data: data
  });
}
export function getCustomRegisterInfo(data) {
  return request({
    url: '/ecargocredit/credit/getCustomRegisterInfo',
    method: 'post',
    data: data
  });
}
export function getInsuranceAndCompanyList(data) {
  return request({
    url: '/ecargocredit/creditCommon/getInsuranceAndCompanyList',
    method: 'post',
    data: data
  });
}